import { Favorite, FavoriteBorder } from '@mui/icons-material'
import { IconButton, Tooltip, Zoom } from '@mui/material'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AppContext } from '../../../Layout/Layout';
import { showToast } from '../../../components/ToastUtils';
import { createUserFavouriteProducts } from '../../../Layout/MutaionsAndQueries';
import { API } from 'aws-amplify';
import { deleteUserFavouriteProducts } from '../../../graphql/mutations';
import CustomTooltip from '../../../components/CustomTooltip';

const FavSection = ({ ProductID }) => {
    const { ProductRelatedStates, userDetails, ProductRelatedDispatch, Actions } = useContext(AppContext);

    const FavListData = ProductRelatedStates.FavProductsList.Data;
    const FavListIDs = ProductRelatedStates.FavProductsList.FavIDs;

    const isFav = useMemo(() => FavListIDs?.includes(ProductID), [FavListIDs, ProductID]);
    const [isFavLoading, setIsFavLoading] = useState(false);

    const addToFavorite = async () => {
        const Inputdata = {
            FavouriteStatus: 'active',
            owner: userDetails.sub,
            productID: ProductID,
            userFavouriteProductsProductDetailId: ProductID
        }
        if (FavListIDs.length !== 36) {
            setIsFavLoading(true);
            await addActions();
            try {
                const response = await API.graphql({
                    query: createUserFavouriteProducts,
                    variables: {
                        input: Inputdata
                    }
                });
                ProductRelatedDispatch({
                    type: Actions.AddFavToFavProductList,
                    payload: { Data: response.data.createUserFavouriteProducts, FavIDs: ProductID }
                })
                setIsFavLoading(false);
            } catch (error) {
                removeActions();
                setIsFavLoading(false);
                console.error("Add to Favorite API error", error)
            }
        }
        else {
            removeActions();
            setIsFavLoading(false);
            showToast("Limit Reached! You can only add 36 products in favourite. ");

        }
    };

    const removeFromFavourite = async () => {
        setIsFavLoading(true);
        const RemoveFavProductIds = await removeActions();
        try {
            const RemoveItemDetails = FavListData.filter((p) => p.id === ProductID);
            const itemToDeleteId = RemoveItemDetails[0].AutoGenID;
            const response = await API.graphql({
                query: deleteUserFavouriteProducts,
                variables: {
                    input: {
                        id: itemToDeleteId
                    }
                }
            });
            if (response) {
                const RemoveFavProduct = FavListData.filter((p) => p.id !== ProductID);
                if (RemoveFavProduct.length > 0) {
                    ProductRelatedDispatch({
                        type: Actions.RemainingFavProducts,
                        payload: { Data: RemoveFavProduct, FavIDs: RemoveFavProductIds }
                    })
                }

            }
            setIsFavLoading(false);

        } catch (error) {
            await addActions();
            setIsFavLoading(false);
            console.error("Error in Removing", error);
            showToast(`Cannot remove this product from favourite. Please contact admin for assistance. `, "error");
        }

    };

    const addActions = async () => {
        ProductRelatedDispatch({ type: Actions.AddFavIDs, payload: { FavIDs: ProductID } })
    }
    const removeActions = async () => {
        const RemoveFavProductIds = FavListIDs.filter((p) => p !== ProductID);
        ProductRelatedDispatch({
            type: RemoveFavProductIds.length === 0 ? Actions.EmptyFavList : Actions.RemainingFavIDs,
            payload: { FavIDs: RemoveFavProductIds }
        })
        return RemoveFavProductIds;
    }

    const FavouriteChangeFn = async () => {

        if (isFav) {
            await removeFromFavourite();
        }
        else {
            await addToFavorite();
        }

    };

    return (
        <div>
            
                <CustomTooltip text={isFav === true ? "Remove from favourites" : "Add to favourites"} placement="bottom">
                <span>
                    <IconButton disabled={isFavLoading} onClick={FavouriteChangeFn}>
                        {isFav === true && <Favorite style={{ fontSize: "0.9rem", color: '#D80032' }} />}
                        {isFav === false && <FavoriteBorder style={{ fontSize: "0.9rem", color: '#D80032' }} />}
                    </IconButton>
                </span>
                </CustomTooltip>
            
        </div>
    )
}

export default FavSection